import { UPDATE_APPROVAL_COUNT } from '../actions/UpdateApprovalCount';

const initialState = {
  approvalCount: 0,
};

const approvalReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_APPROVAL_COUNT:
      return {
        ...state,
        approvalCount: action.payload,
      };
    default:
      return state;
  }
};

export default approvalReducer;